














































































































































import _ from "lodash";
import Vue from "vue";
import Component from "vue-class-component";
import LabelValue from "@/components/miscellaneous/LabelValue.vue";
import {Prop, Watch} from "vue-property-decorator";
import * as Constants from "@/Constants";
import Group from "@/components/miscellaneous/Group.vue";
import InsertionRepository from "@/repositories/insertion/InsertionRepository";


const components = {
    LabelValue,
    Group,
};

@Component({ components })

export default class Detail extends Vue {
    @Prop() public insertionUuid!: string;
    private insertion: any = null;

    @Watch("insertionUuid") private changeInsertion() {
        this.insertion = null;
        this.fetchData();
    }

    private isAdSpace() {
        return this.insertion.type === Constants.typeAdSpace;
    }

    private mounted(): void {
        this.fetchData();
    }

    private fetchData(): void {
        const params = {
            filters: { uuid: this.insertionUuid },
        };

        InsertionRepository.get(params).then((data: object[]) => {
            if (data.length > 0) {
                this.insertion = data[0];
            }
        });
    }

    private get quotationServiceFeesPrice(): number {
        if (!this.insertion) {
            return 0;
        }

        return this.insertion.quotationAdSpaceServiceFeePrice +
            this.insertion.quotationTechnicalFeesServiceFeePrice;
    }

    private get totalAeFtHono(): number {
        if (!this.insertion) {
            return 0;
        }

        return this.insertion.quotationAdSpacePrice +
            this.quotationServiceFeesPrice +
            this.insertion.quotationTechnicalFeesPrice;
    }

    private extractPaymentDates(invoices: any[], acc: any[] = []): any[] {
        return _.reduce(
            invoices,
            (result, invoice) => {
                if (invoice.paymentDate && !_.find(result, { date: invoice.paymentDate })) {
                    result.push({ date: invoice.paymentDate });
                }

                return result;
            },
            acc
        );
    }

    private get cashings(): any[] {
        if (!this.insertion) {
            return [];
        }

        const cashings = this.extractPaymentDates(this.insertion.invoiceClient);

        return this.extractPaymentDates(this.insertion.invoiceFees, cashings);
    }

    private get payments(): any[] {
        if (!this.insertion) {
            return [];
        }

        return this.extractPaymentDates(this.insertion.invoiceSupport);
    }
}
